import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfAlert,
  CcfApprovedIcon,
  CcfAppToastMessage,
  CcfAttachmentDownloadIcon,
  CcfAttachmentPreviewIcon,
  CcfBox,
  CcfButton,
  CcfDoubleArrowIcon,
  CcfEmailJpgIcon,
  CcfEmailPdfIcon,
  CcfEmailReplyIcon,
  CcfPendingApprovalIcon,
  CcfSnackBar,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import React, { useEffect, useState } from 'react';
import styles from './ccf-digital-contact-body.module.scss';
import { DigitalChannelMessage } from './ccf-digital-interaction-module-type';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import {
  activeContactSelector,
  getIsCopilotEmailResponseGenerated,
  selectEmailWithApprovalState,
  setIsCopilotEmailResponseGenerated,
  updateEmailWithApproval,
} from '../../ccf-inbox/ccf-inbox.slice';
import { useDispatch, useSelector } from 'react-redux';
import CcfDigitalEmailTemplate from '../../ccf-digital-email-template/ccf-digital-email-template';
import {
  getEmailHistoryDetails,
  interactionSliceActions,
} from '../ccf-interaction-space.slice';
import CcfInteractionBodyAccordionStyles from '../ccf-interaction-body/ccf-interaction-body-accordion.styles';
import { Box, useTheme } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { CcfAudioPlayer } from '../../ccf-audio-player/ccf-audio-player';
import { toast } from 'react-toastify';

/* eslint-disable-next-line */
export interface CcfDigitalEmailCardProps {
  i: any;
  replyCard?: any;
  emailListLength: number;
  emailDateData: any;
  emailSentDate: any;
  subject: string;
}
/**
 * Component to display EMAIL interaction
 * @example <CcfDigitalMessageCard />
 * @returns twitter card
 */
export function CcfDigitalEmailCard(props: CcfDigitalEmailCardProps) {
  const [hoverIcon, setHoverIcon] = React.useState([false, false, false]);
  const history = useHistory();
  const [translate] = useTranslator();
  const activeContact = useSelector(activeContactSelector);
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const loginCredentialsFirstName =
    loginCredentialsArray[0].charAt(0).toUpperCase() +
    loginCredentialsArray[0].slice(1).toLowerCase();
  const [sentForApproval, setSentForApproval] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [newEmailBox, setNewEmailBox] = useState(false);
  const { setPreviewImgPathData } = interactionSliceActions;
  const dispatch = useDispatch();
  const emailWithApprovalState = useSelector(selectEmailWithApprovalState);
  const emailDateData = useSelector(getEmailHistoryDetails);
  const theme = useTheme();
  const simStyles = CcfInteractionBodyAccordionStyles(theme);
  const isCopilotEmailResponseGenerated = useSelector(
    getIsCopilotEmailResponseGenerated
  );

  /**
   * Function to open email reply click
   * @example - openEmailReplyHandler()
   */
  const openEmailReplyHandler = () => {
    setNewEmailBox(true);
  };

  /**
   * Function to close email reply
   * @example - closeEmailReplyHandler()
   */
  const closeEmailReplyHandler = () => {
    setNewEmailBox(false);
    isCopilotEmailResponseGenerated &&
      dispatch(setIsCopilotEmailResponseGenerated(false));
  };

  /**
   * Used to close the snackbar
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - handleClose()
   */
  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowToast(false);
  };

  // useEffect(() => {
  //   if (isCopilotEmailResponseGenerated) {
  //     openEmailReplyHandler();
  //   }
  // }, [isCopilotEmailResponseGenerated]);

  useEffect(() => {
    setTimeout(() => {
      setShowToast(true);
      setSentForApproval(true);
    }, 5000);
    setTimeout(() => {
      setSentForApproval(false);
      dispatch(updateEmailWithApproval(false));
    }, 10000);
  }, []);

  /**
   * Funtrion to download attchment from email
   * @param e -
   * @example - download('broken-luggage.png')
   */
  function download(attachhment: any) {
    const extension = attachhment.split('.').pop().toLowerCase();
    let downloadfile = '';
    switch (extension) {
      case 'png':
        downloadfile = 'broken-luggage.png';
        break;
      case 'jpg':
        downloadfile = 'broken-luggage.png';
        break;
      case 'pdf':
        downloadfile = 'liam-reimbursement.png';
        break;
      default:
        downloadfile = '';
        break;
    }
    axios({
      url: './../assets/' + downloadfile,
      method: 'GET',
      responseType: 'blob',
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', downloadfile);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  /**
   *Function to open attchment in preview mode
   * @param replyCard -any
   * @example - openPreviewImages()
   */
  async function openPreviewImages(index: any, replyCard: any) {
    const pathArr: any = [];
    replyCard.attachments.map((item: string) =>
      pathArr.push('./../assets/' + item)
    );
    const retVal = await dispatch(setPreviewImgPathData(pathArr));
    history.push('/home/previewMode');
  }

  /**
   * function  to handle hover icon functionality for preview aand download
   * @param param0 - param
   * @example showHoverIcon()
   * @returns
   */
  const showHoverIcon = (i: any) => {
    switch (i) {
      case 0:
        return setHoverIcon([true, false, false]);
      case 1:
        return setHoverIcon([false, true, false]);
      case 2:
        return setHoverIcon([false, false, true]);
    }
  };

  /**
   * function  to handle hover icon functionality for preview aand download
   * @param param0 - param
   * @example hideHoverIcon()
   * @returns
   */
  function hideHoverIcon() {
    setHoverIcon([false, false, false]);
  }

  // /**
  //  *
  //  * @returns -
  //  * @example
  //  */
  // function returnPreviousDate() {
  //   const date = new Date();

  //   date.setDate(date.getDate() - (props.index + 1 || 0));

  //   return date.toLocaleString('en-us', {
  //     month: 'short',
  //     day: '2-digit',
  //     year: 'numeric',
  //   });
  // }

  /**
   * function  to render Icon For Attachments
   * @param param0 - param
   * @example renderIconForAttachments()
   * @returns
   */
  function renderIconForAttachments(param: string) {
    const extension = param.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'png':
      case 'jpg':
        return <CcfEmailJpgIcon />;
      case 'pdf':
        return <CcfEmailPdfIcon />;
      default:
        return '';
    }
  }

  /**
   * function  to render images in preview
   * @param param0 - param
   * @example renderImagesInPreview()
   * @returns
   */
  function renderImagesInPreview(param: string) {
    let type = '';
    param = param.toLowerCase();
    if (
      param.includes('png') ||
      param.includes('jpg') ||
      param.includes('bmp')
    ) {
      type = 'img';
    } else if (param.includes('pdf')) {
      type = 'pdf';
    }
    switch (type) {
      case 'img':
        return (
          <img
            height={105}
            width={150}
            src="./../assets/broken-luggage.png"
            alt={'broken-luggage'}
          />
        );

      case 'pdf':
        return <CcfEmailPdfIcon style={{ height: '60px', width: '60px' }} />;
      default:
        return '';
    }
  }
  /**
   * Method to download attachment
   * @param attachment - current attachment object
   * @example
   * ```
   * downloadFileAttachment(attachment)
   * ```
   */
  const downloadFileAttachment = (attachment: any) => {
    toast.info(<CcfAppToastMessage type="info" messageKey="downloadInfo" />, {
      autoClose: 1000,
      containerId: 'AppToastContainer',
    });
      const link = document.createElement('a');
      link.href = attachment.downloadLink;
      link.setAttribute('download', attachment.fileName);
      document.body.appendChild(link);
      link.click();
      link?.parentNode?.removeChild(link);
  };
  return (
    <>
      {Object.keys(props?.replyCard).length > 0 && (
        <CcfBox
          className={styles.emailCardMainContainer}
          style={{
            marginLeft:
              props?.replyCard?.authorUser.firstName === 'Agent' ? '5%' : '2%',
          }}
        >
          <CcfTypography
            className={
              props?.replyCard?.authorUser.emailAddress ===
              'customer.service@delta.com'
                ? styles.agentName
                : styles.customerName
            }
          >
            {props?.replyCard?.authorUser.emailAddress ===
            'customer.service@delta.com'
              ? props?.replyCard?.authorUser.firstName +
                ' ' +
                props?.replyCard?.authorUser.surname
              : `${[
                  activeContact?.customer?.firstName,
                  activeContact?.customer?.middleName,
                  activeContact?.customer?.lastName,
                ]
                  .filter(Boolean)
                  .join(' ')}`}
          </CcfTypography>
          <CcfBox
            className={styles.originalEmailCard}
            style={{
              background:
                props?.replyCard?.authorUser.firstName !== 'Agent'
                  ? '#FFFFFF'
                  : '#F1F1F1',
            }}
          >
            {emailAccordionHeader(
              translate,
              props?.replyCard,
              activeContact,
              props?.emailSentDate,
              simStyles,
              props?.subject,
              loginCredentialsFirstName
            )}
            <div style={{ padding: '10px' }}>
              <div
                contentEditable={false}
                className={styles.orignalEmailText}
                dangerouslySetInnerHTML={{
                  __html:
                    props?.replyCard?.messageContent?.payload?.text.replace(
                      'Liam Davis',
                      activeContact?.customer.firstName +
                        ' ' +
                        activeContact?.customer.lastName
                    ) || '',
                }}
              ></div>
              {props?.replyCard &&
                props?.replyCard?.attachments?.length > 0 && (
                  <CcfBox style={simStyles.emailCard}>
                    {props?.replyCard?.attachments.map(
                      (attachment: any, index: any) => 
                        attachment.fileType !== 'audio/mpeg' ?
                        (
                        <CcfBox
                          style={{ height: '150px', width: '150px' }}
                          className={styles.originalEmailAttchmentBlock}
                        >
                          <div
                            style={{ height: '30%' }}
                            className={styles.originalEmailAttchmentFirstBlock}
                          >
                            {renderIconForAttachments(attachment)}
                            <div className={styles.attchmentFileAndSizeGroup}>
                              <CcfTypography className={styles.attchedFileName}>
                                {attachment}
                              </CcfTypography>
                              <CcfTypography className={styles.attchedFileSize}>
                                372 KB
                              </CcfTypography>
                            </div>
                          </div>
                          <div
                            style={{ height: '70%' }}
                            className={styles.originalEmailAttchmentSecondBlock}
                            id={'attachment' + index}
                            onMouseEnter={() => showHoverIcon(index)}
                            onMouseLeave={hideHoverIcon}
                          >
                            {renderImagesInPreview(attachment)}
                            {hoverIcon[index] === true && (
                              <div className={styles.hoverBackground}>
                                <div
                                  className={styles.hoverPreviewBlock}
                                  onClick={() =>
                                    openPreviewImages(index, props?.replyCard)
                                  }
                                >
                                  <CcfAttachmentPreviewIcon />
                                  <CcfTypography
                                    className={styles.hoverIconText}
                                    translationKey={'preview'}
                                  />
                                </div>
                                <div
                                  className={styles.hoverDownloadBlock}
                                  onClick={() => download(attachment)}
                                >
                                  <CcfAttachmentDownloadIcon />
                                  <CcfTypography
                                    className={styles.hoverIconText}
                                    translationKey={'download'}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </CcfBox>
                      ) : (
                        <Box component="div" sx={{ paddingRight: '4.6rem'}}>
                            <CcfAudioPlayer
                              audioUrl={attachment.downloadLink}
                              isInbound={false}
                              attachment={attachment}
                              shouldShowDownloadIcon
                              fileName={attachment.fileName || ''}
                              handleDownloadAttachment={downloadFileAttachment}
                            />
                          </Box>
                      )
                    )}
                  </CcfBox>
                )}
              {props?.i === props?.emailListLength - 1 && (
                <CcfBox
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <CcfButton
                    primary
                    variant="contained"
                    color="primary"
                    startIcon={<CcfEmailReplyIcon />}
                    onClick={openEmailReplyHandler}
                    id="agent_email_replyButton"
                  >
                    {translate('reply')}
                  </CcfButton>
                </CcfBox>
              )}
            </div>
            {emailWithApprovalState &&
              activeContact?.customer.replywithApproval === 'Yes' &&
              props?.i === props?.emailListLength - 1 && (
                <CcfBox
                  className={
                    sentForApproval
                      ? styles.approvalApprovedNotification
                      : styles.approvalPendingNotification
                  }
                >
                  {sentForApproval ? (
                    <CcfApprovedIcon
                      style={{
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  ) : (
                    <CcfPendingApprovalIcon
                      style={{
                        marginLeft: '10px',
                        fill: 'transparent',
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  )}
                  <div className={styles.approvalTextAndTimerBlock}>
                    <CcfTypography className={styles.txtApprovals}>
                      {sentForApproval
                        ? 'Message Approved & Sent'
                        : 'Pending Approval'}
                    </CcfTypography>
                    <CcfTypography className={styles.txtApprovalTimer}>
                      5 minutes ago
                    </CcfTypography>
                  </div>
                </CcfBox>
              )}
            <CcfBox>
              {emailWithApprovalState &&
                activeContact?.customer.replywithApproval === 'Yes' &&
                props?.i === props?.emailListLength - 1 && (
                  <CcfSnackBar
                    onClose={() => handleClose()}
                    open={showToast}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  >
                    <div>
                      <CcfAlert closeAlert={handleClose} severity="success">
                        Your email was approved & sent
                      </CcfAlert>
                    </div>
                  </CcfSnackBar>
                )}
            </CcfBox>
          </CcfBox>
        </CcfBox>
      )}
      {(newEmailBox || Object.keys(props?.replyCard).length === 0) && (
        <CcfDigitalEmailTemplate
          closeEmailReplyHandler={closeEmailReplyHandler}
        />
      )}
      {isCopilotEmailResponseGenerated && (
        <CcfDigitalEmailTemplate
          closeEmailReplyHandler={closeEmailReplyHandler}
        />
      )}
    </>
  );
}

/**
 *Function to display email accordion header
 * @param replyCard - any
 * @param activeContact - any
 * @example renderdaysDiff()
 */
function renderdaysDiff(dateTwo: any) {
  const date1: any = new Date();
  const date2: any = new Date(dateTwo.toString());

  const diffTime = Math.abs(date1 - date2);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays === 1) {
    const copydate1 = date1.toLocaleString('en-us', {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
    return `${copydate1} (Today)`;
  } else if (diffDays === 2) {
    return `${dateTwo} (${diffDays - 1} day ago)`;
  } else {
    return `${dateTwo} (${diffDays - 1} days ago)`;
  }
}

/**
 *Function to display email accordion header
 * @param replyCard - any
 * @param activeContact - any
 * @example emailAccordionHeader()
 */
export function emailAccordionHeader(
  translate: any,
  replyCard: any,
  activeContact: any,
  emailSentDate: any,
  simStyles: any,
  subject: string,
  loginCredentialsFirstName?: string
) {
  return (
    <CcfAccordion sx={simStyles.accordionContainer}>
      <CcfAccordionSummary
        sx={simStyles.accordionHeader}
        expandIcon={<CcfDoubleArrowIcon sx={simStyles.expandedIcon} />}
      >
        <div
          className={styles.padding5px}
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <CcfTypography className={styles.accordionEmailText}>
            {translate('from')}:
            {replyCard?.authorUser.firstName === 'Agent' ||
            replyCard?.authorUser.firstName === loginCredentialsFirstName
              ? ' ' + replyCard?.authorUser.emailAddress
              : ' ' + activeContact?.customer?.emailId}
          </CcfTypography>
          <CcfTypography className={styles.accordionEmailDateAndTImeText}>
            {renderdaysDiff(emailSentDate)}
          </CcfTypography>
        </div>
      </CcfAccordionSummary>
      <CcfAccordionDetails sx={simStyles.setAccordionDetailsItem}>
        <div
          className={styles.padding5px}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <CcfTypography className={styles.accordionEmailText}>
            {translate('to')}:
            {replyCard?.authorUser.firstName === 'Agent' ||
            replyCard?.authorUser.firstName === loginCredentialsFirstName
              ? ' ' + activeContact?.customer?.emailId
              : ' ' + 'customer.service@delta.com'}
          </CcfTypography>
          <CcfTypography className={styles.accordionEmailText}>
            {translate('subject')}: {subject}
          </CcfTypography>
        </div>
      </CcfAccordionDetails>
    </CcfAccordion>
  );
}

export default CcfDigitalEmailCard;
